export class StringTool{
    static mergeClassName=(...classes:string[])=>{
        let arr = classes.filter(t=>t)
        return arr.join(" ")
    }
}